/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReceiptBankAccountResponseDto
 */
export interface ReceiptBankAccountResponseDto {
    /**
     * Bank account number
     * @type {string}
     * @memberof ReceiptBankAccountResponseDto
     */
    bankNumber: string;
    /**
     * Source broker name
     * @type {string}
     * @memberof ReceiptBankAccountResponseDto
     */
    bankName: string;
    /**
     * Currency code
     * @type {string}
     * @memberof ReceiptBankAccountResponseDto
     */
    currencyCode: string;
}

/**
 * Check if a given object implements the ReceiptBankAccountResponseDto interface.
 */
export function instanceOfReceiptBankAccountResponseDto(value: object): value is ReceiptBankAccountResponseDto {
    if (!('bankNumber' in value) || value['bankNumber'] === undefined) return false;
    if (!('bankName' in value) || value['bankName'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function ReceiptBankAccountResponseDtoFromJSON(json: any): ReceiptBankAccountResponseDto {
    return ReceiptBankAccountResponseDtoFromJSONTyped(json, false);
}

export function ReceiptBankAccountResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiptBankAccountResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'bankNumber': json['bankNumber'],
        'bankName': json['bankName'],
        'currencyCode': json['currencyCode'],
    };
}

export function ReceiptBankAccountResponseDtoToJSON(json: any): ReceiptBankAccountResponseDto {
    return ReceiptBankAccountResponseDtoToJSONTyped(json, false);
}

export function ReceiptBankAccountResponseDtoToJSONTyped(value?: ReceiptBankAccountResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bankNumber': value['bankNumber'],
        'bankName': value['bankName'],
        'currencyCode': value['currencyCode'],
    };
}

